import { useEffect, useState } from "react";
import FaqAccordianContent from "./FaqAccordionContent";
import { AiOutlinePlus } from "react-icons/ai";
import { BsArrowRight } from "react-icons/bs";
import style from "./style.module.css";
import { trackWebEngageEvent } from "../../../../../Utils/Webengageevent/webengageUtils";
import { getItemLocal, getUserId } from "../../../../../common_utilities";
import Cookies from 'js-cookie';
import { BASE_API_URL } from "../../../../../constants";
function FaqAccordian({ planDetails }) {
  const [activeIndex, SetActiveIndex] = useState(null);
  const [leadid, setLeadId] = useState(null);
  const faqItems = [
    {
      id: 0,
      question: "What is ITR filing on a video call?",
      answer:
        "ITR filing over a one-on-one video call is an innovative method of filing your Income Tax Returns (ITR). It involves a real-time collaboration between a person who wishes to file ITR and a Tax Expert over a LIVE call.",
    },
    {
      id: 1,
      question: "What is the process of filing ITR on a video call?",
      answer:
        "First, you are required to schedule an appointment with the tax expert by selecting your preferred date and time. Once you schedule the appointment, you will get a list of documents which you need to keep ready on the day of the appointment. At the time of the appointment, you and the tax expert will connect over a live video call via Google Meet, Skype, Zoom or MS Teams. The tax expert will guide you step-by-step to file our ITR.",
    },
    {
      id: 3,
      question: "Is filing ITR online over a video call reliable?",
      answer:
        "Yes, filing your ITR online over a live video call is a new concept, but it is as reliable as filing your ITR using the traditional way with your CA.",
    },
    {
      id: 5,
      question:
        "Will the tax expert answer my tax and ITR filing-related questions?",
      answer:
        "Yes, in case you have any questions related to your ITR filing and taxation, you can surely ask the tax expert, and the expert will answer them during the call.",
    },
  ];


  const updateAccordionIndex = (idx) => {
    const faq = faqItems.find((item) => item.id === idx);

    trackWebEngageEvent("faq clicked", {
      url: window.location.href,
      "list price": planDetails?.plan_amount || 0,
      MRP: planDetails?.plan_original_price || 0,
      "list discount":
        (planDetails?.plan_original_price || 0) -
        (planDetails?.plan_amount || 0),
      "plan name": planDetails?.plan_name || "",
      "plan id": planDetails?.plan_id || "",
      "Lead ID": String(leadid) || "",
      faq: faq?.question || "",
      service: "ITR",
    });

    if (activeIndex === idx) {
      SetActiveIndex(null);
    } else {
      SetActiveIndex(idx);
    }
  };


  const isActive = (idx) => activeIndex === idx;

  const lead_id = Cookies.get("rm_id") || null;


  // const [CalTag, setCalTag] = useState(null);
  const CheckLead = async () => {
    debugger;
    try {
      const url = `${BASE_API_URL}restapi/userflow/check_lead_api/?user_id=${getUserId()}&log_service_id=91&assesment_year=Y`;
      const response = await fetch(url);
      const result = await response.json();

      if (result?.status_code === "200" && result?.data?.log_tag) {
        // setCalTag(result.data.log_tag);
        setLeadId(result.data.log_id)
      }
    } catch (error) {
      console.error("CheckLead API error:", error);
    }
  };

  useEffect(() => {
    CheckLead();
  })

  return (
    <>
      <div>
        {faqItems.map((item) => (
          <div className="accordian-item" key={item.id}>
            <div
              className={`${style["accordian-header"]}`}
              onClick={() => updateAccordionIndex(item.id)}
              style={
                isActive(item.id)
                  ? { color: "#042b62" }
                  : { color: "black" }
              }
            >
              <span>{item.question}</span>
              {isActive(item.id) ? <BsArrowRight /> : <AiOutlinePlus />}
            </div>
            <FaqAccordianContent activeIndex={isActive(item.id)}>
              <div>
                <p>{item.answer}</p>
              </div>
            </FaqAccordianContent>
          </div>
        ))}
      </div>
    </>
  );
}

export default FaqAccordian;
